import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    // Primary colors - Rongeka Africa brand palette
    colorPrimary: '#E89B3C',      // Brand orange
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    colorInfo: '#2C5F8D',         // Brand navy blue
    
    // Background colors
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f7fa',
    colorBgElevated: '#ffffff',
    
    // Text colors
    colorText: '#2c3e50',
    colorTextSecondary: '#6c757d',
    colorTextDisabled: '#bfbfbf',
    
    // Border
    colorBorder: '#e8e8e8',
    borderRadius: 6,
    
    // Typography
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    
    // Spacing
    padding: 16,
    margin: 16,
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#1a3a52',
      bodyBg: '#f5f7fa',
    },
    Menu: {
      darkItemBg: '#1a3a52',
      darkItemSelectedBg: '#E89B3C',
      darkItemHoverBg: '#2C5F8D',
      darkSubMenuItemBg: '#0f2433',
      darkPopupBg: '#1a3a52',
    },
    Button: {
      controlHeight: 40,
      borderRadius: 6,
      colorTextLightSolid: '#ffffff', // White text on solid/primary buttons
    },
    Input: {
      controlHeight: 40,
      borderRadius: 6,
    },
    Card: {
      borderRadius: 8,
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
    },
  },
};
